import React from "react";
import "./LegalPage.css";

export default function Terms() {
  return (
    <div className="legal-container">
      <div className="legal-card">
        <h1 className="legal-title">Terms &amp; Conditions</h1>

        <div className="legal-section">
          <p>
            Welcome to ActivityBuddy (“ActivityBuddy”, “we”, “our”, “us”). These
            Terms &amp; Conditions (“Terms”) form a binding agreement between you
            (“you”, “user”, “customer”, “host”, “creator”, or “ActivityBuddy user”)
            and ActivityBuddy.
          </p>
          <p>
            By accessing or using ActivityBuddy, you agree to these Terms. If you
            do not agree, do not use the platform.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>1. Overview of ActivityBuddy</h3>
          <p>
            ActivityBuddy is a platform that enables individuals (“Hosts”) to offer
            social, recreational, or skill-based activities, and enables other
            individuals (“Customers”) to request to participate in those
            activities.
          </p>
          <p>
            ActivityBuddy is not a party to any interaction, meeting, activity, or
            transaction between users. Hosts are independent individuals, not
            employees or agents of ActivityBuddy.
          </p>
          <p>We provide the technology — not the service.</p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>2. Eligibility</h3>
          <p>To use ActivityBuddy, you represent and warrant that:</p>
          <ul className="legal-list">
            <li>You are at least 18 years old.</li>
            <li>You have full power and authority to enter into these Terms.</li>
            <li>You will provide accurate information, including your real legal name.</li>
            <li>You are not prohibited from using our services under any applicable law.</li>
          </ul>
          <br />
          <p>
            We may, at any time, suspend or terminate accounts for violations of
            these Terms or for safety concerns.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>3. Platform Role &amp; Disclaimer</h3>
          <p>ActivityBuddy:</p>
          <ul className="legal-list">
            <li>Does not employ users</li>
            <li>Does not vet backgrounds or run criminal checks (unless stated otherwise)</li>
            <li>Does not supervise activities or guarantee safety</li>
            <li>Does not guarantee the accuracy of user content</li>
            <li>Is not responsible for the conduct of any user online or offline</li>
          </ul>
          <br />
          <p>
            You understand that meeting strangers carries inherent risks, and you
            accept full responsibility for your own safety and decisions.
          </p>
          <p>
            You agree to use common sense, meet in public places, and immediately
            leave any situation that feels unsafe.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>4. User Responsibilities</h3>
          <p>You agree that you will:</p>
          <ul className="legal-list">
            <li>Use ActivityBuddy legally and respectfully</li>
            <li>Provide accurate and truthful information</li>
            <li>Communicate promptly about schedule changes</li>
            <li>Not engage in harassment, violence, stalking, hate speech, or harmful behavior</li>
            <li>Not offer or request illegal services, including sexual services</li>
            <li>Not attempt to circumvent the platform</li>
          </ul>
          <br />
          <p>Users who violate these obligations may be removed without notice.</p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>5. Activity Policies</h3>

          <h4>5.1 Hosts</h4>
          <p>Hosts agree that:</p>
          <ul className="legal-list">
            <li>You are solely responsible for the activities you offer</li>
            <li>You will describe your activities accurately</li>
            <li>You will show up at the agreed time and location</li>
            <li>You will comply with all applicable laws and venue rules</li>
            <li>You will not misrepresent your identity, expertise, or intentions</li>
            <li>You accept full responsibility for your interactions with Customers</li>
          </ul>

          <h4>5.2 Customers</h4>
          <p>Customers agree that:</p>
          <ul className="legal-list">
            <li>You will show up as agreed</li>
            <li>You will treat Hosts respectfully</li>
            <li>You will not coerce Hosts into activities outside the described purpose</li>
            <li>You understand Hosts may accept or decline at their discretion</li>
            <li>You will not use the platform for dating, solicitation, or sexual services</li>
          </ul>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>6. Payments &amp; Payouts</h3>
          <p>Payments are processed by Stripe. ActivityBuddy does not store card numbers or banking information.</p>

          <h4>6.1 Customer Charges</h4>
          <ul className="legal-list">
            <li>A hold is placed on a Customer provided payment method at time of submitting a request.</li>
            <li>Customers are charged only when a Host accepts their request.</li>
            <li>Declined requests are not charged.</li>
            <li>
              Additional activity costs (entrance fees, food, tickets, etc.) are paid
              directly by the Customer unless stated otherwise.
            </li>
            <li>ActivityBuddy does not offer cancellations for booking requests. ActivityBuddy support reviews requests on a case by case basis.</li>
          </ul>

          <h4>6.2 Host Payouts</h4>
          <ul className="legal-list">
            <li>Hosts receive earnings after the activity occurs.</li>
            <li>Payouts require a connected Stripe account.</li>
            <li>We are not responsible for delays or compliance checks by Stripe.</li>
            <li>
              We may adjust, withhold, or refuse payouts due to fraud, disputes, or
              violations.
            </li>
          </ul>

          <h4>6.3 Platform Fees</h4>
          <p>ActivityBuddy charges a platform fee on each booking. Fees may change.</p>

        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>7. Cancellations, No-Shows, Refunds &amp; Disputes</h3>

          <h4>7.1 Host No-Show</h4>
          <p>
            If a Host does not show up, ActivityBuddy may refund the Customer and
            may take action the Host's account.
          </p>

          <h4>7.2 Customer No-Show</h4>
          <p>
            If a Customer no-shows, the Host may still receive payout unless
            ActivityBuddy determines otherwise.
          </p>

          <h4>7.3 Disputes</h4>
          <p>
            Users must contact ActivityBuddy support about a specific activity request for assistance. All dispute resolutions are final and at our
            sole discretion. Refunds are not guaranteed.
          </p>
          <h4>7.4 Cancellations</h4>
          <p>
            Once a request is accepted by a Host, it is considered a confirmed booking. Changes or cancellations are considered disputes, are not guaranteed, and are handled at ActivityBuddy’s sole discretion.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>8. Safety &amp; Prohibited Activities</h3>
          <br />
          <ul className="legal-list">
            <li>No sexual services</li>
            <li>No illegal activity</li>
            <li>No drugs, weapons, or controlled substances</li>
            <li>No violence, threats, or harassment</li>
            <li>No impersonation</li>
            <li>No collection of sensitive data</li>
            <li>No bringing users to private homes without consent</li>
            <li>No using the platform to stalk, exploit, or harm others</li>
          </ul>
          <br />
          <p>
            ActivityBuddy may report serious violations to authorities when legally
            required.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>9. Reviews &amp; Feedback</h3>
          <p>
            After activities, both Hosts and Customers may leave feedback. Reviews
            may be private or public depending on platform development. By posting
            a review, you grant ActivityBuddy a perpetual, royalty-free license to
            use it. You may not include hateful, confidential, or defamatory
            content.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>10. Account Suspension or Termination</h3>
          <p>We may suspend or terminate accounts for:</p>
          <ul className="legal-list">
            <li>Safety concerns</li>
            <li>Fraud or deceptive behavior</li>
            <li>Repeated no-shows</li>
            <li>Abusive conduct</li>
            <li>Illegal or inappropriate use</li>
            <li>Any violation of these Terms</li>
          </ul>
          <br />
          <p>Users removed for misconduct are not entitled to refunds or payouts.</p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>11. Platform Content &amp; Intellectual Property</h3>
          <p>
            ActivityBuddy owns all software, branding, logos, UI/UX, website
            content, and marketing materials. Users may not copy, reverse engineer,
            scrape, or build derivative products from ActivityBuddy.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>12. Limitation of Liability</h3>
          <p>
            To the maximum extent permitted by law, ActivityBuddy is not liable for
            personal injury, emotional distress, financial loss, or harm resulting
            from interactions between users. The platform is provided “as is”
            without warranties of any kind. Your use of ActivityBuddy is at your
            own risk.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>13. Indemnification</h3>
          <p>
            You agree to indemnify, defend, and hold harmless ActivityBuddy, its
            founders, employees, contractors, and affiliates from any claims,
            damages, or losses arising from your use of the platform, activities,
            interactions, or violations of these Terms.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>14. Governing Law</h3>
          <p>
            These Terms are governed by the laws of the State of Florida. Any
            disputes must be resolved exclusively in the courts of that state.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>15. Changes to Terms</h3>
          <p>
            We may update these Terms at any time. Continued use of the platform
            constitutes acceptance of the updated Terms.
          </p>
        </div>

        <div className="legal-section">
          <hr className="legal-divider" />
          <h3>16. Contact</h3>
          <p>Questions? Contact us at support@activitybuddy.com.</p>
        </div>
      </div>
    </div>
  );
}